import { useLoaderData } from 'react-router';
import { PunchoutContentBlockWrapper } from '../../../../components/Punchout/PunchoutContentBlockWrapper.js';
import type { Category } from '../../../../common/types/category.js';
import type { PageResponse } from '../../../../generated/api/pageResponse';

interface PunchoutStoreProductProps {
  category: Category;
}

export const PunchoutStoreProduct = ({ category }: PunchoutStoreProductProps) => {
  const page = useLoaderData() as PageResponse;

  return <PunchoutContentBlockWrapper category={category} page={page} />;
};
